import { Link, useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FFFDF9] bg-grain grid place-items-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center bg-white border border-slate-200 rounded-2xl p-10 shadow-sm">
        <Link to="/" className="inline-flex items-center gap-2 mb-8" data-testid="brand-link">
          <div className="w-9 h-9 rounded-lg bg-[#0A2540] grid place-items-center text-white font-bold font-display">R</div>
          <span className="font-display font-semibold text-lg">ReviewFlow</span>
        </Link>
        <XCircle className="w-14 h-14 mx-auto text-slate-400" />
        <h1 className="mt-6 font-display text-2xl font-bold text-[#0A2540]">Pagamento annullato</h1>
        <p className="mt-2 text-slate-600 text-sm">Nessun addebito è stato effettuato. Puoi riprovare quando vuoi.</p>
        <div className="mt-6 flex gap-2 justify-center">
          <Button onClick={() => navigate("/")} variant="outline" className="rounded-full">Home</Button>
          <Button onClick={() => navigate("/#pricing")} className="rounded-full bg-[#0A2540] hover:bg-[#0A2540]/90 text-white">Vedi piani</Button>
        </div>
      </div>
    </div>
  );
}
